import { getAcademicYearsByIdUrl, getAcademicYearsUrl } from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class AcademicYearService {
  static getAcademicYears = () => {
    return getRequest(getAcademicYearsUrl());
  };

  static updateAcademicYear = (yearId, params) => {
    return putRequest(getAcademicYearsByIdUrl(yearId), params);
  };

  static createAcademicYear = (params) => {
    return postRequest(getAcademicYearsUrl(), params);
  };

  static deleteAcademicYear = (yearId) => {
    return deleteRequest(getAcademicYearsByIdUrl(yearId));
  };
}
